<div class="content-inner">
  <div class="title-bar">
    <div class="container-fluid">
      <h2 class="page-title">{{ 'AUTHORIZATION.REGISTRATION' | translate }}</h2>
    </div>
  </div>
  <div class="container-fluid">
    <div class="my-4">
      <h3 class="section-title">{{ 'AUTHORIZATION.BASIC_INFORMATION' | translate }}</h3>
    </div>
    <form class="form-container" name="userSigninFormBasicInfo" [formGroup]="userSigninFormBasicInfo">
      <div class="my-4 mx-3">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="inputName">{{ translationKeys.ProfileDetails.Name | translate }}</label><span class="mandatory">*</span>
              <input inputSanitizer type="text" class="form-control" formControlName="inputName" name="inputName"
                placeholder="{{ 'USER_MANAGEMENT.ENTER_NAME' | translate }}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="inputUserName">{{ translationKeys.Authorization.Username | translate }}</label><span
                class="mandatory">*</span>
              <input inputSanitizer type="text" class="form-control" name="inputUserName" formControlName="inputUserName"
                placeholder="{{ 'USER_MANAGEMENT.ENTER_USERNAME' | translate }}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="inputEmail">{{ translationKeys.ProfileDetails.Email | translate }}</label><span class="mandatory">*</span>
              <input inputSanitizer type="email" class="form-control" name="inputEmail" formControlName="inputEmail"
                placeholder="{{ 'USER_MANAGEMENT.ENTER_MAIL_ADDRESS' | translate }}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="exampleInputPassword1">{{ 'AUTHORIZATION.PASSWORD' | translate }}</label><span
                class="mandatory">*</span>
              <small
                class="form-text font-italic text-muted">{{ 'USER_MANAGEMENT.GENERATED_PASSWORD_SEND_TO_REGISTERED_MAIL' | translate }}</small>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="my-4">
      <h3 class="section-title">{{ 'AUTHORIZATION.INSTITUTION_INFORMATION' | translate }}</h3>
    </div>
    <form class="form-container" name="userSigninFormInstitutionInfo" [formGroup]="userSigninFormInstitutionInfo">
      <div class="my-4 mx-3">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="institutionName">{{ translationKeys.ProfileDetails.InstitutionName | translate }}</label><span
                class="mandatory">*</span>
              <input inputSanitizer type="text" class="form-control" formControlName="institutionName" name="institutionName"
                placeholder="{{ 'USER_MANAGEMENT.ENTER_NAME' | translate }}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="InputAddress1">{{ 'AUTHORIZATION.ADDRESS_LINE_1' | translate }}</label><span
                class="mandatory">*</span>
              <input inputSanitizer type="text" class="form-control" name="InputAddress1" formControlName="InputAddress1"
                placeholder="{{'INSTITUTION_MANAGEMENT.ENTER_ADDRESS_LINE_1' | translate}}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="InputAddress2">{{ 'AUTHORIZATION.ADDRESS_LINE_2' | translate }}</label><span
                class="mandatory">*</span>
              <input inputSanitizer type="text" class="form-control" name="InputAddress2" formControlName="InputAddress2"
                placeholder="{{'INSTITUTION_MANAGEMENT.ENTER_ADDRESS_LINE_2' | translate}}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="inputCity">{{ 'AUTHORIZATION.CITY' | translate }}</label><span class="mandatory">*</span>
              <input inputSanitizer type="text" class="form-control" name="inputCity" formControlName="inputCity"
                placeholder="{{ 'INSTITUTION_MANAGEMENT.ENTER_CITY' | translate }}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="InputState">{{ 'AUTHORIZATION.STATE' | translate }}</label><span class="mandatory">*</span>
              <input inputSanitizer type="text" class="form-control" name="InputState" formControlName="InputState"
                placeholder="{{'INSTITUTION_MANAGEMENT.ENTER_STATE' | translate }}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="InputZipCode">{{'INSTITUTION_MANAGEMENT.POSTAL_CODE' | translate }}</label><span
                class="mandatory">*</span>
              <input inputSanitizer type="text" class="form-control" name="InputZipCode" formControlName="InputZipCode"
                placeholder="{{'INSTITUTION_MANAGEMENT.ENTER_POSTAL_CODE' | translate}}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="inputCountry">{{ 'AUTHORIZATION.COUNTRY' | translate }}</label><span
                class="mandatory">*</span>
              <input inputSanitizer type="text" class="form-control" name="inputCountry" formControlName="inputCountry"
                placeholder="{{ 'INSTITUTION_MANAGEMENT.ENTER_CITY' | translate }}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="InputPhone">{{ 'AUTHORIZATION.PHONE' | translate }}</label><span class="mandatory">*</span>
              <input inputSanitizer type="text" class="form-control" name="InputPhone" formControlName="InputPhone"
                placeholder="{{'INSTITUTION_MANAGEMENT.ENTER_PHONE' | translate }}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="InputFax">{{ 'AUTHORIZATION.FAX' | translate }}</label><span class="mandatory">*</span>
              <input inputSanitizer type="text" class="form-control" name="InputFax" formControlName="InputFax"
                placeholder="{{ 'INSTITUTION_MANAGEMENT.ENTER_FAX' | translate }}">
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="InputPackage">{{ 'AUTHORIZATION.PRODUCT_PACKAGE' | translate }}</label><span
                class="mandatory">*</span>
              <select class="form-control" name="InputPackage" formControlName="InputPackage">
                <option>{{ 'AUTHORIZATION.SELECT_PACKAGE' | translate }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="my-4 mx-3">
      <div class="row">
        <div class="col my-4">
          <button (click)="saveUser(true)" class="btn btn-primary mr-4">{{ translationKeys.Authorization.Save | translate }}</button>
          <button (click)="saveUser(false)" class="btn btn-seondary">{{ translationKeys.Authorization.Cancel | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
